define([
    'WebCommon/api'
], function(
    CommonApi
){
    var Api = CommonApi.Api;

    return {
        homeGalleryApi: new Api('/s/gallery/getHomeData'),
        getProductDetailApi: new Api('/s/shop/product/getDetail'),
        getSlideApi: new Api('/s/sitebanner/getSlideByType'),
        getProductListApi: new Api('/s/product-list/getByCategory'),
        getProductsByBomApi: new Api('/s/product-list/getByBom'),

        searchProductsApi: new Api('/s/shop/product/search'),

        getBrandDetailV2: new Api('/s/gallery/getBrandDetailV2'),
        getExhibit: new Api('/m/s/fnjiexhibit/get'),

        applyExhibit: new Api('/s/exhibithis/apply'),


        getInterview: new Api('/m/s/fnjiinterview/get'),

        addCartApi: new Api('/s/cart/add-goods'),

        // getBrandGcrApi: new Api('http://fnji.com/s/brand/getBrandGcr'),//品牌
        // getByBrandApi: new Api('http://fnji.com/s/product-list/getByBrand'),//品牌详情页
        getBrandGcrApi: new Api('/s/brand/getBrandGcr'),//品牌
        getByBrandApi: new Api('/s/product-list/getByBrand'),//品牌详情页



    };
});



//////////////////
// WEBPACK FOOTER
// ./common/api.js
// module id = 18
// module chunks = 0 1 2 3 4 5 6